import * as modalsConstants from './modalsConstants';
import * as modalsActions from './modalsActions';
import modalsReducer from './modalsReducer';

export { modalsReducer, modalsActions, modalsConstants };
